import { ImagePicture } from 'approot/shared/images/images';

import emojiPopperAvif from './image-emoji-popper.avif';
import emojiPopperWebp from './image-emoji-popper.webp';
import emojiPopperPng from './image-emoji-popper.png';

const ImageEmojiPopper = ({ width, ...rest }: { width?: number }) => (
  <ImagePicture
    lazyLoad={false}
    style={width ? { width } : undefined}
    avif={{ path: emojiPopperAvif }}
    webp={{ path: emojiPopperWebp }}
    png={{ path: emojiPopperPng }}
    {...rest}
  />
);

export default ImageEmojiPopper;
